/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_TitleInputs */

const en_guide_json_vs_yaml_xml_title = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON vs YAML vs XML: When to Use Which: PureJSON`)
};

const ko_guide_json_vs_yaml_xml_title = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON vs YAML vs XML: 언제 어떤 것을 사용할까: PureJSON`)
};

const ja_guide_json_vs_yaml_xml_title = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON vs YAML vs XML：どれを使うべきか: PureJSON`)
};

/**
* | output |
* | --- |
* | "JSON vs YAML vs XML: When to Use Which: PureJSON" |
*
* @param {Guide_Json_Vs_Yaml_Xml_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_title = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_title(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_title(inputs)
	return ja_guide_json_vs_yaml_xml_title(inputs)
});